import { getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { DeviationsLoader } from "../deviations.loader";
import { DeviationsLoaderUtils } from "../deviations.loader.utils";
import { Debug } from "@utils/debug";
import { IRawDeviation } from "@propely/propely-typings";
import { Utilities } from "@utils/utilities";

export class DeviationsChunkLoader {
  deviationsLoader: DeviationsLoader;

  totalQueryCount = 0;
  finishedQueryCount = 0;
  deviations: IRawDeviation[] = [];
  startDate = new Date();
  loaded = false;
  loading = false;

  constructor(deviationsLoader: DeviationsLoader) {
    this.deviationsLoader = deviationsLoader;
  }

  loadFirstBatch() {
    this.startDate = new Date();
    this.loaded = false;
    this.loading = true;
    this.totalQueryCount = 0;
    this.finishedQueryCount = 0;
    this.deviations = [];

    console.log("[DeviationsChunkLoader] Loading deviations");
    const landlordOrOperationManagerChunks = DeviationsLoaderUtils.getLandlordOrOperationManagerPropertyChunks();
    return Promise.allSettled(landlordOrOperationManagerChunks.map((chunk) => this.loadBatch(chunk)));
  }

  private loadBatch(chunk: string[]): Promise<any> {
    const queryLimit = 100;
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 3);

    this.totalQueryCount++;

    return getDocs(
      query(
        DeviationsLoaderUtils.getCollectionGroup(),
        DeviationsLoaderUtils.getPropertyIdWhere(chunk),
        orderBy("reportDate", "desc"),
        where("reportDate", "<=", maxDate),
        limit(queryLimit)
      )
    )
      .then(async (snapshot) => {
        this.finishedQueryCount++;

        for (const doc of snapshot.docs) {
          const parsedDeviation = DeviationsLoaderUtils.parseIRawDeviationFromDocumentSnapshot(doc);
          if (parsedDeviation) {
            this.deviations.push(parsedDeviation);
          }
        }

        if (this.totalQueryCount === this.finishedQueryCount) {
          this.finishedLoading();
        }
      })
      .catch((error) => {
        console.error("[DeviationsChunkLoader] Error loading deviations");
        console.error(error);
      });
  }

  private finishedLoading() {
    Debug.print("[DeviationsChunkLoader] Finished loading deviations");
    Debug.print("[DeviationsChunkLoader] Total queries " + this.totalQueryCount);
    Debug.print("[DeviationsChunkLoader] Finished queries " + this.finishedQueryCount);
    Debug.print("[DeviationsChunkLoader] Total deviations " + this.deviations.length);
    Debug.print("[DeviationsChunkLoader] Time " + (new Date().getTime() - this.startDate.getTime()) + " ms");
    this.loaded = true;
    this.loading = false;
    this.deviationsLoader.addDeviations(this.deviations, "DeviationsChunkLoader");
  }
}

